export default __webpack_public_path__ + "static/media/galarie7.de9cd5ed.jpg";